// extracted by mini-css-extract-plugin
export var actions = "_uh-4";
export var item = "_uh-1";
export var price = "_uh-3";
export var quantity = "_uh-2";
export var table = "_uh-0";